import React, { useState, useEffect } from "react";
import loginImage from "../../assets/Login 1 Orange.png";
import { FiUser } from "react-icons/fi";
import { RiLock2Line } from "react-icons/ri";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { Link, useNavigate } from "react-router-dom";
import LoginSubmitWhiteIcon from "../../assets/Icons/RegisterLoginIconOrange.png";
import CustomAlert from "../../helpers/CustomAlert";
import "../../css/Login.css";
import { toast } from "react-toastify";
import CircularProgress from "@mui/material/CircularProgress";
import { axiosPostApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";
import { useDispatch } from "react-redux";
import LoginOtpModal from "./LoginOtpModal";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import ResetOtpModal from "./ResetOtpModal";
import encryptAES from "../../helpers/encryption";

function LoginForm() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [responseData, setresponseData] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isModalOpenOtp, setIsModalOpenOtp] = useState(false);
  const [visitorId, setVisitorId] = useState("");
  const [isResetModalOpenOtp, setIsResetModalOpenOtp] = useState(false);

  const openModalOtp = () => {
    setIsModalOpenOtp(true);
  };

  const closeModalOtp = () => {
    setIsModalOpenOtp(false);
  };

  useEffect(() => {
    const loadFingerprint = async () => {
      const fp = await FingerprintJS.load();
      const result = await fp.get();
      setVisitorId(result.visitorId); // this is the fingerprint hash
    };

    loadFingerprint();
  }, []);

  const handleOtp = async (event) => {
    if (event) event.preventDefault();
    setLoading(true);

    try {
      const encryptedPassword = encryptAES(password);
      const encryptedUsername = encryptAES(username);
      const encryptedVisitorId = encryptAES(visitorId);

      const loginData = {
        username: encryptedUsername,
        password: encryptedPassword,
        deviceFingerprint: encryptedVisitorId,
      };

      const response = await axiosPostApi(apiList.LOGIN_OTP, loginData);
      const respCode = response?.data?.respCode;

      if (response?.data?.status && respCode === "00") {
        setLoading(false);
        setresponseData(response?.data?.data);
        openModalOtp();
        toast.success("OTP Sent", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else if (respCode === "02") {
        // Case when respCode is 02 (Set Password)
        setLoading(false);
        CustomAlert({
          title: "Set Password Required",
          text:
            response?.data?.message ||
            "You need to set your password to continue.",
          icon: "warning",
          confirmButtonText: "Set Password",
        }).then((result) => {
          if (result.isConfirmed) {
            setTimeout(() => {
              navigate(
                `/auth/set-password?username=${encodeURIComponent(username)}`
              );
            }, 500); // Add a slight delay to allow the Swal alert to close properly
          }
        });
      } else if (respCode === "07") {
        setLoading(false);
        CustomAlert({
          title: "Login Failed",
          text:
            response?.data?.message || "Invalid credentials. Please try again!",
          icon: "info",
          confirmButtonText: "Reset",
          cancelButtonText: "Cancel",
          showCancelButton: true,
          cancelButtonColor: "#d33",
        }).then((result) => {
          if (result.isConfirmed) {
            handleResetUserName();
          } else if (result.isDismissed) {
            console.log("Cancellll");
          }
        });
      } else {
        // For all other cases, show an error
        setLoading(false);
        CustomAlert({
          title: "Login Failed",
          text:
            response?.data?.message || "Invalid credentials. Please try again!",
          icon: "error",
          confirmButtonText: "Retry",
        });
      }
    } catch (error) {
      // Handle error case
      setLoading(false);
      console.error("Encryption/Login Error:", error);
      CustomAlert({
        title: "Error",
        text: "Error occurred while logging in. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    }
  };

  const handleResetUserName = async () => {
    // event.preventDefault();
    const encryptedUsername = encryptAES(username);

    const payload = {
      username: encryptedUsername,
    };
    try {
      const response = await axiosPostApi(apiList.RESET_USERNAME, payload);
      const respCode = response?.data?.respCode;
      if (response?.data?.status && respCode === "00") {
        setIsResetModalOpenOtp(true);
        setresponseData(response?.data?.data);
        toast.success("OTP Sent", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } catch (error) {
      toast.error("Failed to send reset link");
    }
  };

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <>
      <div className="login-form-root-element container-fluid w-100">
        <div className="row align-items-center login-container">
          {/* Form Section */}
          <div
            className="login-form-parent col-md-6 d-flex flex-column justify-content-center"
            style={{ textAlign: "center" }}
          >
            <p className="text-left">
              Access Your Account{" "}
              <span style={{ fontWeight: "400" }}>to Get Started!</span>
            </p>
            <form
            //  onSubmit={handleSubmit}
            >
              <div className="login-form-main-division form-floating mb-3">
                <input
                  type="text"
                  className="form-control login-inputs"
                  id="floatingInput"
                  placeholder="Username"
                  value={username}
                  onChange={(event) => setUsername(event.target.value)}
                />
                <label
                  htmlFor="floatingInput"
                  className="flex items-center !pl-2 gap-2"
                >
                  <FiUser /> Username
                </label>
              </div>
              <div className="form-floating mb-3">
                <input
                  type={showPassword ? "text" : "password"}
                  className="form-control login-inputs"
                  id="floatingPassword"
                  placeholder="Password"
                  value={password}
                  onChange={(event) => setPassword(event.target.value)}
                />
                <label
                  htmlFor="floatingPassword"
                  className="flex items-center !pl-2 gap-2"
                >
                  <RiLock2Line /> Password
                </label>
                <span onClick={toggleShowPassword} className="showpwd">
                  {showPassword ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
                </span>
              </div>
              <div className="mb-3" style={{ fontSize: "0.8rem" }}>
                <span>Forgot Password? </span>
                <Link to="/auth/forgot-password" className="text-primary">
                  Reset it here
                </Link>
              </div>
              <div className="login-btn-container">
                <div
                  //  type="submit"
                  // onClick={openModalOtp}
                  onClick={handleOtp}
                  className="btn loginNow-btn"
                >
                  {/* If loading, show loader, else show button */}
                  {loading ? (
                    <CircularProgress
                      className="circular-loader"
                      style={{
                        width: "20px",
                        height: "20px",
                        color: "#ff702b",
                      }}
                    />
                  ) : (
                    <span className="login-text">Login Now</span>
                  )}
                </div>

                <span onClick={handleOtp} className="login-icon">
                  <img
                    src={LoginSubmitWhiteIcon}
                    alt="LoginIcon"
                    className="h-[52px]"
                  />
                </span>
              </div>
              {errorMessage && (
                <p style={{ color: "red", textAlign: "center" }}>
                  {errorMessage}
                </p>
              )}
            </form>
          </div>

          {/* Image Section */}
          <div className="col-md-6 d-none d-md-block login-image">
            <img
              src={loginImage}
              alt="Login Illustration"
              className="img-fluid"
            />
          </div>
        </div>
      </div>
      {isModalOpenOtp ? (
        <LoginOtpModal
          handleopenOtp={isModalOpenOtp}
          handleCloseOtp={closeModalOtp}
          password={password}
          username={username}
          responseData={responseData}
          deviceFingerprint={visitorId}
          handleOtp={handleOtp}
        />
      ) : null}

      {isResetModalOpenOtp ? (
        <ResetOtpModal
          handleopenOtp={isResetModalOpenOtp}
          handleCloseOtp={() => setIsResetModalOpenOtp(false)}
          username={username}
          responseData={responseData}
          handleResentOTP={handleResetUserName}
        />
      ) : null}
    </>
  );
}

export default LoginForm;
